module.exports = __webpack_public_path__ + "static/media/38_A.8cde5910.png";